import { ListContainer } from "common/components/lists/ListContainer";
import { ListItem } from "common/components/lists/ListItem";
import { MultilineText } from "common/components/MultilineText";
import { default as React } from "react";
import { MultipleChoiceData } from "__generated__/types";
import { QuestionState } from "./MultipleChoice";
import styles from "./MultipleChoiceQuestion.module.css";

interface Props {
  question: MultipleChoiceData["questions"][0];
  value: QuestionState;
  onChange: (value: QuestionState) => void;
}

export const MultipleChoiceQuestion: React.FC<
  React.PropsWithChildren<Props>
> = ({ question, value, onChange }) => {
  return (
    <form>
      <section key={question.id}>
        <legend className={styles.question}>{question.title}</legend>
        {question.body && (
          <MultilineText {...question.body} openLinksSeparately />
        )}
        <ListContainer className={styles.list} key={question.id}>
          {question.options?.map((option) => (
            <ListItem
              className={
                value.selectedOptions.includes(option.id)
                  ? styles.checked + " " + styles.option
                  : styles.option
              }
              key={option.id}
            >
              <label className={styles.label} htmlFor={option.id}>
                <input
                  className={styles.input}
                  type="checkbox"
                  name={`options[${option.id}]`}
                  id={option.id}
                  checked={value.selectedOptions.includes(option.id)}
                  onChange={(e) => {
                    onChange({
                      selectedOptions: e.target.checked
                        ? value.selectedOptions.concat([option.id])
                        : value.selectedOptions.filter((it) => it != option.id),
                    });
                  }}
                />
                {option.title}
              </label>
            </ListItem>
          ))}
        </ListContainer>
      </section>
    </form>
  );
};
